var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SummarySection(props) {
    return (_jsxs("div", __assign({ className: props.className }, { children: [_jsx("h3", __assign({ className: "text-lg font-medium" }, { children: props.title }), void 0), _jsx("table", __assign({ className: "table-fixed w-full border mt-3" }, { children: _jsx("tbody", { children: props.children }, void 0) }), void 0)] }), void 0));
}
